import { render } from "./Portfolio.vue?vue&type=template&id=452afe92"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=452afe92&lang=scss&global=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/Portfolio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "452afe92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('452afe92', __exports__)) {
    api.reload('452afe92', __exports__)
  }
  
  module.hot.accept("./Portfolio.vue?vue&type=template&id=452afe92", () => {
    api.rerender('452afe92', render)
  })

}


export default __exports__